export default __webpack_public_path__ + "cad728eba7ad794c63237e821e9833b4.png";